module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 036563f6
// module chunks = 14 15 17 18 21 22 25